'use client';

import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function ChartSection() {
  // Pie Chart Data - Product Mix Distribution
  const pieData = {
    labels: ['HECM Fixed Rate', 'HECM Adjustable', 'HECM for Purchase', 'Proprietary Reverse'],
    datasets: [
      {
        data: [45, 30, 15, 10],
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Bar Chart Data - Quarterly Sales Comparison
  const barData = {
    labels: ['Q1', 'Q2', 'Q3', 'Q4'],
    datasets: [
      {
        label: 'North Region',
        data: [1200, 1400, 1650, 1900],
        backgroundColor: 'rgba(255, 99, 132, 0.8)',
      },
      {
        label: 'South Region',
        data: [1000, 1550, 1400, 1750],
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
      },
      {
        label: 'East Region',
        data: [950, 1300, 1550, 1650],
        backgroundColor: 'rgba(255, 206, 86, 0.8)',
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 2000,
      },
    },
  };

  return (
    <div style={{ display: 'flex', gap: '40px', marginTop: '30px' }}>
      <div style={{ flex: 1 }}>
        <h2>Product Mix Distribution</h2>
        <div style={{ maxWidth: '400px', margin: '0 auto' }}>
          <Pie data={pieData} />
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <h2>Quarterly Sales Comparison</h2>
        <Bar data={barData} options={barOptions} />
      </div>
    </div>
  );
}
